module.exports = __webpack_public_path__ + "img/20190716161803649.834689e2.png";